import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const NivoGridContainer = styled(Flex)(({ theme }) => ({
  height: '100%',
  width: '100%',
  flexGrow: 1,
  borderRadius: 10,
  flexDirection: 'column',
  padding: theme.spacing(6, 6, 10, 10),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(7),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 6, 3, 3),
  },
}));

export const NivoGridCard = styled(NivoGridContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[500]}`,
}));
